type PauseIconProps = {
  className?: string;
};

const PauseIcon: React.FC<PauseIconProps> = ({ className = '' }) => (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0 14H4V0H0V14ZM8 0V14H12V0H8Z" fill="#202020" />
    </svg>
  );

export default PauseIcon;
